/**
 * Согласование query-параметров списка обращений с classic `frontend/src/pages/Tickets.js`
 * (подстраницы, exclude_resolved_closed, канонизация status/priority для NativeSelect).
 */

const TICKETS_KNOWN_STATUS_SLUGS = new Set([
  'new',
  'open',
  'in_progress',
  'pending',
  'on_hold',
  'emergency',
  'resolved',
  'closed',
])

const TICKETS_PRIORITY_SLUGS = new Set(['low', 'normal', 'high', 'urgent'])

/** Как `isSubpage` в Tickets.js: есть ли в URL «узкий» фильтр списка */
export function ticketsUrlHasSubpageStyleFilters(sp: URLSearchParams): boolean {
  if ((sp.get('status') || '').trim()) return true
  if ((sp.get('priority') || '').trim()) return true
  if (sp.get('urgent') === 'true') return true
  return false
}

/**
 * Значение exclude_resolved_closed для API.
 * На подстраницах по умолчанию false, если параметр не задан явно.
 */
export function excludeResolvedClosedFromSearchParams(sp: URLSearchParams): boolean {
  const er = sp.get('exclude_resolved_closed')
  if (er === 'true') return true
  if (er === 'false') return false
  if (ticketsUrlHasSubpageStyleFilters(sp)) return false
  return true
}

/** Чекбокс «Без реш./закр.» в панели фильтров */
export function excludeResolvedClosedDraftFromParams(sp: URLSearchParams): boolean {
  if (ticketsUrlHasSubpageStyleFilters(sp)) {
    return sp.get('exclude_resolved_closed') === 'true'
  }
  return sp.get('exclude_resolved_closed') !== 'false'
}

export function canonicalStatusQueryValue(raw: string): string {
  const s = raw.trim()
  if (!s) return ''
  return s
    .split(',')
    .map((part) => {
      const t = part.trim().toLowerCase()
      return TICKETS_KNOWN_STATUS_SLUGS.has(t) ? t : part.trim()
    })
    .filter(Boolean)
    .join(',')
}

export function canonicalPriorityQueryValue(raw: string): string {
  const s = raw.trim()
  if (!s) return ''
  return s
    .split(',')
    .map((part) => {
      const t = part.trim().toLowerCase()
      return TICKETS_PRIORITY_SLUGS.has(t) ? t : part.trim()
    })
    .filter(Boolean)
    .join(',')
}
